﻿import WMSCapabilities from 'ol/format/WMSCapabilities';
import TileWMS from 'ol/source/TileWMS.js';
import TileLayer from 'ol/layer/Tile.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
//import { Utility } from '../Utility.js';
import { Settings } from './Settings.js';
export { searchNetworkTool };

/**
 * Class Identify
 */
const searchNetworkTool = function () {

    // Define this
    var mysearchNetworkTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    //// Utility
    //this._utility = new Utility();

    // Result Search Network 
    this._resultRefDataSearch = {};

    // Array data Network 
    this.featureHashNetwork = [];

    // Array column expand
    this._columnDefArrayExpand = {};

    // Hash that contains all features 
    this._hashFeatures = {};

    this._hasConsumptionPoint = false;

    this._consumptionPointLayerName = "";

    this._exportFlag = false;

    this._hiddenColumnsForExport = [];

    this._gridPageSize = 20;

    this._templateChooseFieldForExport = '<label class="k-column-list-item">' +
        '<input class="k-checkbox" style="position: relative !important; left: 0px !important; opacity: 1 !important;" type="checkbox" title="[TITLE]" data-field="[FIELD]" checked />' +
        '<span class="k-checkbox-label"> [TITLE]</span>' +
        '</label>';

    // style network
    this._styleNetworkDefault =
        new Style({
            image: new CircleStyle({
                radius: 7,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.8)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.8)',
                width: 5
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.2)'
            })
        });

    // 

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Get all features by search
     * @param {any} WorkspaceAndlayerName
     * @param {any} geoserver
     * @param {any} async
     * @param {any} cqlFilter
     * @param {any} style
     * @param {any} geomColumnName
     */
    this.GetAllFeaturesBySearch = function (WorkspaceAndlayerName, geoserver, async, cqlFilter, style, geomColumnName) {

        var getFeatureUrl = geoserver + "/wfs";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: async,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": WorkspaceAndlayerName,
                "cql_filter": cqlFilter,
                //"propertyName": (geomColumnName == null ? 'geom' : geomColumnName),
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            mysearchNetworkTool._mapSgs.layerHighlightOverlay.getSource().clear();
            if (data.features.length > 0) {

                //Get All documents 
                mysearchNetworkTool.getAllDocumentsById();

                mysearchNetworkTool._mapSgs._arraySearchLayerFeatureActive = [];
                for (var i = 0; i < data.features.length; i++) {

                    mysearchNetworkTool._mapSgs._arraySearchLayerFeatureActive.push((new GeoJSON()).readFeatures(data)[i]);
                    mysearchNetworkTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[i]);
                    var styleElement = mysearchNetworkTool._styleNetworkDefault;

                    var styleCustom = mysearchNetworkTool._resultRefDataSearch.listLayer.find(c => c.layer_name == data.features[i].id.split('.')[0]);

                    if (styleCustom && styleCustom.style_color) {

                        var NewStyleCustom =
                            new Style({
                                image: new CircleStyle({
                                    radius: 7,
                                    stroke: new Stroke({
                                        color: 'rgba(255, 255, 0, 0.8)',
                                        width: 5
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(0, 0, 255, 0.2)'
                                    })
                                }),
                                stroke: new Stroke({
                                    color: styleCustom.style_color,
                                    width: 5
                                }),
                                fill: new Fill({
                                    color: 'rgba(0, 0, 255, 0.2)'
                                })
                            });

                        styleElement = NewStyleCustom;
                    }
                    mysearchNetworkTool._mapSgs.featureToHighLight.getArray()[mysearchNetworkTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                }
                // Go to Feature
                mysearchNetworkTool._mapSgs.map.getView().fit(mysearchNetworkTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: mysearchNetworkTool._mapSgs.map.getSize(), duration: 1000 });

                mysearchNetworkTool._mapSgs._arraySearchLayerFeatureActive = [];

                // Number of result
                $('#id-search-result-detail-info-number-result span')[0].innerHTML = data.features.length;

                $('#id-offcanvas-search-result-expand').css('display', 'none');
                $('#id-offcanvas-search-result-expand-zone').css('display', 'none');
                $('#id-offcanvas-search-result-goto-zone')[0].className = "col col-md-4 col-xs-4";
                $('#id-offcanvas-search-result-clean-zone')[0].className = "col col-md-4 col-xs-4";

                mysearchNetworkTool.FilterResults(data);

            } else {
                mysearchNetworkTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
                toastr["warning"]("Não foi encontrada, nenhuma camada");
            }
        });
    };

    /**
     * Filter all results
     * @param {any} ListFeatures
     */
    this.FilterResults = function (ListFeatures) {

        for (var ii = 0; ii < mysearchNetworkTool._resultRefDataSearch.listLayer.length; ii++) {

            var MetadataLayer;

            var ListlayerFilterSource;

            var LayerToCheck;

            var ListlayerFilterCql = [];

            MetadataLayer = mysearchNetworkTool._resultRefDataSearch.layerByCodLayerMetadata.filter(c => c.cod_layer_metadata == mysearchNetworkTool._resultRefDataSearch.listLayer[ii].cod_layer_metadata)

            if (MetadataLayer.length != 0) {

                ListlayerFilterSource = ListFeatures.features.filter(c => c.id.split('.')[0] == mysearchNetworkTool._resultRefDataSearch.listLayer[ii].layer_name.split('.')[0]);

                LayerToCheck = mysearchNetworkTool._resultRefDataSearch.layerByCodLayerMetadata.find(c => c.cod_layer_metadata == mysearchNetworkTool._resultRefDataSearch.listLayer[ii].cod_layer_metadata);

                if (LayerToCheck.cql_filter == null) {

                    mysearchNetworkTool._hashFeatures[LayerToCheck.pretty_name] = $(ListlayerFilterSource).map(function () { return this.properties; });;

                    mysearchNetworkTool.CreateDatatables(LayerToCheck.pretty_name, ListlayerFilterSource, MetadataLayer[0].id)

                } else {

                    for (var iii = 0; iii < ListlayerFilterSource.length; iii++) {

                        if (ListlayerFilterSource[iii].properties[$.trim(LayerToCheck.cql_filter.split('=')[0])] == $.trim(LayerToCheck.cql_filter.split('=')[1]).replaceAll("'", "")) {
                            ListlayerFilterCql.push(ListlayerFilterSource[iii]);
                        }
                    }

                    if (ListlayerFilterCql.length != 0) {
                        mysearchNetworkTool._hashFeatures[LayerToCheck.pretty_name] = $(ListlayerFilterCql).map(function () { return this.properties; });
                        mysearchNetworkTool.CreateDatatables(LayerToCheck.pretty_name, ListlayerFilterCql, MetadataLayer[0].id)
                    }
                }
            }
        }
    }

    /**
     * Create Dinamic datatables
     * @param {any} NameLayer
     * @param {any} ListLayers
     * @param {any} idLayer
     */
    this.CreateDatatables = function (NameLayer, ListLayers, idLayer) {
        if (ListLayers.length > 0 && ListLayers[0].id.split('.')[0] === mysearchNetworkTool._consumptionPointLayerName)
            mysearchNetworkTool._hasConsumptionPoint = true;
        else
            mysearchNetworkTool._hasConsumptionPoint = false;

        var ListLayersFilter = {};

        var properties = {
            name: "urn:ogc:def:crs:EPSG::3763"
        };

        var crs = {
            properties: properties,
            type: "name"
        };

        ListLayersFilter = {
            crs: crs,
            features: ListLayers,
            numberMatched: 0,
            numberReturned: 0,
            timeStamp: ListLayers.timeStamp,
            totalFeatures: 0,
            type: "FeatureCollection"
        }

        if (ListLayersFilter.features.length > 0) {
            var layerName = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.layerName;
            var nameLayerNorm = $.trim(NameLayer).replaceAll(' ', '');

            $('#offcanvas-search-result-network-table-zone').append('<div id="offcanvas-' + nameLayerNorm + '" class= "row mCustomScrollbar padding-fix extra-padding div-datatable-network" data-mcs-axis="yx" data-mcs-theme="rounded-dark"> ' +
                '<label id="label-' + nameLayerNorm + '" class="networkSearchDatatable">' + NameLayer + '</label>' +
                '<i class= "fa fa-expand networksearchExpand"></i> <div style="display: none;" id="div-' + $.trim(NameLayer).replaceAll(' ', '') + '">' +
                '<table id="table-' + nameLayerNorm + '" pretty-name="' + nameLayerNorm + '" id-layer="' + idLayer + '" layer-name = "' + layerName + '"  class="display Layer-' + layerName + ' search-network-tool-table" cellspacing="0"></table></div ></div > ');

            $('#id-offcanvas-search-result-body').css('display', 'block');

            $('#offcanvas-search-result-table-zone').css('display', 'none');

            var feature = null;
            var layerName = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.layerName;
            var workspace = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info.workspace;
            var columnDefArray = [];
            var columDefArrayExpand = [];
            var columDefArrayExpandSize = [];
            var columnValueArray = [];
            var idPrimaryKey = null;
            var featureHash = {};
            for (let i = 0; i < ListLayersFilter.features.length; i++) {
                feature = (new GeoJSON()).readFeatures(ListLayersFilter)[i];
                idPrimaryKey = feature.getId().split(".")[1];
                mysearchNetworkTool.featureHashNetwork.push(feature);
                //featureHash[idPrimaryKey] = feature;

                // Save feature Search
                mysearchNetworkTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                // Build column info
                var objRow = {};
                for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                    var columnName = Object.keys(feature.getProperties())[j];
                    if (columnName === "geometry")
                        continue;
                    var value = feature.getProperties()[columnName];
                    var columnProperties = mysearchNetworkTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                        return obj.column_name === columnName
                    })[0];

                    // If value is a system date, format string
                    //if (new Date(value) != 'Invalid Date' && isNaN(value))
                    if (columnProperties) {
                        if (columnProperties.column_type == 'xsd:date-time')
                            value = app.sgs._utility.TransformDateServerInDateTime(value);

                        objRow[columnName] = value;
                        if (columDefArrayExpandSize[columnName]) {
                            if (value) {
                                var valueSize = value.toString().length;
                                columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                            }
                        }
                        else {
                            if (value)
                                columDefArrayExpandSize[columnName] = value.toString().length;
                            else
                                columDefArrayExpandSize[columnName] = 30; // If fist empty
                        }
                        if (i === 0) {
                            const columnDef = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName);

                            if (columnDef) {

                                if (columnDef.visible) {
                                    columDefArrayExpand.push(columnDef);
                                }

                                if (columnDef.search_result) {
                                    columnDefArray.push({
                                        'data': columnDef.column_name,
                                        'title': columnDef.pretty_name,
                                        'name': columnDef.pretty_name,
                                        'label': columnDef.pretty_name,
                                        'type': columnDef.column_type,
                                        'className': 'dt-column-search',
                                        'orderable': false,
                                        'width': '30px',
                                        'visible': true,
                                        'search_order': columnDef.search_result_order
                                    });
                                } else {
                                    columnDefArray.push({
                                        'data': columnDef.column_name,
                                        'type': 'readonly',
                                        'visible': false,
                                        'search_order': 0
                                    });
                                }
                            }
                        }
                    }
                }
                // Order columns by search order
                columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                // Add primary key value
                objRow["id_primary_key"] = idPrimaryKey;

                // Add array row
                columnValueArray.push(objRow);
            }

            // Add primary key to array
            columnDefArray.push({
                'data': "id_primary_key",
                'type': 'readonly',
                'visible': false
            });

            // Canvas search result
            mysearchNetworkTool._mapSgs._utility.ShowOpenCanvas3('offcanvas-search-result', true);

            // Make datatable list
            mysearchNetworkTool.InitSearchResultTable(workspace, layerName, mysearchNetworkTool._mapSgs.layerTree.selectedLayerSearch, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, mysearchNetworkTool._mapSgs.DetailElement, $.trim(NameLayer).replaceAll(' ', ''));

            // Go to Feature
            mysearchNetworkTool._mapSgs.map.getView().fit(mysearchNetworkTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: mysearchNetworkTool._mapSgs.map.getSize() });

            // Remove hide in offcanvas search result information
            $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
            // $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
            mysearchNetworkTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        }
    }

    /**
     * Create Dinamic datatables
     * @param {any} tableName
     * @param {any} arrayFeature
     * @param {any} idLayer
     */
    this.CreateDatatables2 = function (tableName, arrayFeature, idLayer) {

        if (arrayFeature.length > 0) {
            // Get layer info
            var layerInfo = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].layer_info;
            // Normalize table name
            var tableNameNorm = $.trim(tableName).replaceAll(' ', '');

            // Verify if layer is a consumption point
            if (layerInfo.layerName === mysearchNetworkTool._consumptionPointLayerName)
                mysearchNetworkTool._hasConsumptionPoint = true;
            else
                mysearchNetworkTool._hasConsumptionPoint = false;

            // Create html table
            $('#offcanvas-search-result-network-table-zone').append('<div id="offcanvas-' + tableNameNorm + '" class= "row mCustomScrollbar padding-fix extra-padding div-datatable-network" data-mcs-axis="yx" data-mcs-theme="rounded-dark"> ' +
                '<label id="label-' + tableNameNorm + '" class="networkSearchDatatable">' + tableName + '</label>' +
                '<i class= "fa fa-expand networksearchExpand" id-layer="' + idLayer + '"></i> <div style="display: none;" id="div-' + tableNameNorm + '">' +
                '<table id="table-' + tableNameNorm + '" pretty-name="' + tableNameNorm + '" id-layer="' + idLayer + '" layer-name = "' + layerInfo.layerName + '"  class="display Layer-' + layerInfo.layerName + ' search-network-tool-table" cellspacing="0"></table></div ></div > ');
            $('#id-offcanvas-search-result-body').css('display', 'block');
            $('#offcanvas-search-result-table-zone').css('display', 'none');

            // For every feature
            var columnDefArray = [];
            var columDefArrayExpand = [];
            var columDefArrayExpandSize = [];
            var columnValueArray = [];
            for (let i = 0; i < arrayFeature.length; i++) {
                var feature = arrayFeature[i];
                var idPrimaryKey = feature.getId().split(".")[1];
                mysearchNetworkTool.featureHashNetwork.push(feature);

                // Save feature Search
                mysearchNetworkTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                // Build column info
                var objRow = {};
                for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                    var columnName = Object.keys(feature.getProperties())[j];
                    if (columnName === "geometry")
                        continue;
                    var value = feature.getProperties()[columnName];
                    var columnProperties = mysearchNetworkTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                        return obj.column_name === columnName
                    })[0];

                    // If value is a system date, format string
                    //if (new Date(value) != 'Invalid Date' && isNaN(value))
                    if (columnProperties) {
                        if (columnProperties.column_type == 'xsd:date-time')
                            value = app.sgs._utility.TransformDateServerInDateTime(value);

                        objRow[columnName] = value;
                        if (columDefArrayExpandSize[columnName]) {
                            if (value) {
                                var valueSize = value.toString().length;
                                columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                            }
                        }
                        else {
                            if (value)
                                columDefArrayExpandSize[columnName] = value.toString().length;
                            else
                                columDefArrayExpandSize[columnName] = 30; // If column has no value
                        }
                        if (i === 0) {
                            var columnSearchResult = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                            var visible = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                            var columnPrettyName = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                            var searchResultOrder = mysearchNetworkTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                            if (columnSearchResult) {
                                columnDefArray.push({
                                    'data': columnName,
                                    'title': columnPrettyName,
                                    'name': columnPrettyName,
                                    'label': columnPrettyName,
                                    'type': columnPrettyName,
                                    'className': 'dt-column-search',
                                    'orderable': false,
                                    'width': '30px',
                                    'search_order': searchResultOrder
                                });
                            } else {
                                columnDefArray.push({
                                    'data': columnName,
                                    'type': 'readonly',
                                    'visible': false,
                                    'search_order': 0
                                });
                            }
                            if (visible) {
                                columDefArrayExpand.push({
                                    'data': columnName,
                                    'title': columnPrettyName,
                                    'name': columnPrettyName,
                                    'label': columnPrettyName,
                                    'type': columnPrettyName,
                                    'orderable': false,
                                    'width': '30px'
                                });
                            }
                            else {
                                columDefArrayExpand.push({
                                    'data': columnName,
                                    'type': 'readonly',
                                    'visible': false
                                });
                            }
                        }
                    }
                }
                // Order columns by search order
                columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                // Add primary key value
                objRow["id_primary_key"] = idPrimaryKey;

                // Add array row
                columnValueArray.push(objRow);
            }

            // Add primary key to array
            columnDefArray.push({
                'data': "id_primary_key",
                'type': 'readonly',
                'visible': false
            });

            // Add size to column in array expand
            for (let i = 0; i < columDefArrayExpand.length; i++) {
                var objDef = columDefArrayExpand[i];
                if (objDef.width) {
                    if (columDefArrayExpandSize[objDef.data] > 50)
                        objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                    else
                        objDef.width = "50px";
                    columDefArrayExpand[i] = objDef;
                }
            };

            //   canvas search result
            mysearchNetworkTool._mapSgs._utility.ShowOpenCanvas3('offcanvas-search-result', true);

            // Make datatable list
            mysearchNetworkTool.InitSearchResultTable(layerInfo.workspace, layerInfo.layerName, mysearchNetworkTool._mapSgs.layerTree.selectedLayerSearch, {}, columnDefArray, columDefArrayExpand, columnValueArray, mysearchNetworkTool._mapSgs.DetailElement, tableNameNorm);

            // Remove hide in offcanvas search result information
            $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
            mysearchNetworkTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        }
    }

    /**
     * Init search result table
     * @param {string} workspace, workspace
     * @param {string} layerName, layer name
     * @param {int} idLayer, layer id
     * @param {object} featureHash, feature
     * @param {array} columnDefArrayInput, array of column
     * @param {array} columDefArrayExpandInput, array of column for expand table
     * @param {array} columnValueArray, array of value
     * @param {function} gotoEntityDetailCallback, goto entity callback function
     */
    this.InitSearchResultTable = function (worksapce, layerName, idLayer, featureHash, columnDefArrayInput, columDefArrayExpandInput, columnValueArray, gotoEntityDetailCallback, idDatatable) {
        var columnDefArray = columnDefArrayInput;
        mysearchNetworkTool._columnDefArrayExpand[idDatatable] = columDefArrayExpandInput;
        mysearchNetworkTool._hashFeatures[idDatatable] = columnValueArray;

        // Go to detail
        var objDef = {
            'name': 'button_goto_detail',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-goto-detail btn-column',
            'defaultContent': '<a class="button-goto-detail-search-result-network" title="Ir para o detalhe do elemento"><i class="gpi gpi-info" style="color: #ff3d00"></i></a>',
            'width': '20px'
        };
        columnDefArray.unshift(objDef);

        // Goto to location
        objDef = {
            'name': 'button_goto_location',
            'data': null,
            'orderable': false,
            'className': 'dt-body-center btn-goto-location btn-column',
            'defaultContent': '<a class="button-goto-location-search-result-network" title="Ir para a posição do elemento"><i class="zmdi zmdi-gps-dot" style="color: #ff3d00"></i></a>',
            'width': '20px'
        };
        columnDefArray.unshift(objDef);

        var idRow = "id_primary_key";

        if (mysearchNetworkTool._hasConsumptionPoint) {

            // Goto to location
            objDef = {
                'name': 'button_goto_webService',
                'data': null,
                'orderable': false,
                'className': 'dt-body-center btn-goto-webservice-network btn-column',
                'defaultContent': '<a class="button-goto-webservice-network" title="Informação Predio"><i class="fa fa-home" style="color: #ff3d00; margin-right: 5px;display: initial;"></i></a>',
                'width': '20px'
            };
            columnDefArray.unshift(objDef);

            idRow = 'cod_ponto_cons';
        }

        // -- Table search result -----------------------------------------------------------------

        // Destroy if exists
        if (mysearchNetworkTool._mapSgs.datatableSearchResult != null) {
            // Destroy mCustomScrollbar
            $('#offcanvas-search-result-table-zone.mCustomScrollbar').mCustomScrollbar('destroy');

            // Destroy table
            mysearchNetworkTool._mapSgs.datatableSearchResult.destroy();

            // Empty table zone
            $('#offcanvas-search-result-table-zone').empty();

            // Recreate table node
            var tableSearch = $('<table id="offcanvas-search-result-table" cellspacing="0"></table>');
            tableSearch.appendTo($('#offcanvas-search-result-table-zone'));
        }

        // -- Table definition --
        var tableResultSearch = $('#table-' + idDatatable).DataTable({
            "dom": 'frtp',
            "destroy": true,
            "buttons": [
                'copy', 'excel', 'pdf' //, 'print'
            ],
            "language": {
                "search": "",
                "searchPlaceholder": "Procurar",
                "emptyTable": 'Nenhum elemento',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": true,
            "info": false,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "pagingType": "full",
            "paging": true,
            "ordering": false,
            "columns": columnDefArray,
            "data": columnValueArray,
            "select": false,
            "name": "search_result",
            "rowId": idRow,
            "initComplete": function (settings, json) {

                // Unbind pass event
                $('.button-goto-detail-search-result-network').unbind("click");
                $('.button-goto-location-search-result-network').unbind("click");
                $('.button-goto-webservice-network').unbind("click");
                $('.networkSearchDatatable').unbind("click");
                $('.networksearchExpand').unbind("click");

                // Open/Close datatable
                $('.networkSearchDatatable').off('click').on('click', function () {

                    if (this.id.split('label-')[1] != "") {

                        if ($('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').is(':visible'))
                            $('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').css('display', 'none');
                        else
                            $('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').css('display', 'block');
                    }
                });

                //// Open/Close datatable
                //$('.networksearchExpand').on('click', function () {
                //    mysearchNetworkTool.InitSearchResultTableExtend(null, null, null, mysearchNetworkTool._hashFeatures[$.trim($(this).siblings('label')[0].innerText).replaceAll(' ', '')], mysearchNetworkTool._columnDefArrayExpand[$.trim($(this).siblings('label')[0].innerText).replaceAll(' ', '')]);
                //});
            },
            "drawCallback": function (settings) {
                // Add count number
                var tableId = 'table-' + idDatatable;
                $("#" + tableId + "-page-info").remove();
                $("#" + tableId + "_paginate").prepend($('<span id="' + tableId + '-page-info" class="table-page-number">' + ($('#' + tableId).DataTable().page.info().page + 1) + "/" + ($('#' + tableId).DataTable().page.info().pages) + '</span>'));
                $("#" + tableId + "-row-number").remove();
                $("#" + tableId + "_paginate").prepend($('<span id="' + tableId + '-row-number" class="table-row-number">Registos: ' + $('#' + tableId).DataTable().rows({ search: 'applied' }).count() + '</span>'));
                $("#" + tableId + "_filter").css("text-align", "left");

                // Goto element detail
                $('.button-goto-detail-search-result-network').off('click').on('click', function () {
                    var id = $(this).parent().parent()[0].id;

                    var layerName = $(this.closest('table')).attr('layer-name');
                    var idFeature = layerName + "." + id;
                    var prettyName = $(this.closest('table')).attr('pretty-name');

                    var features = mysearchNetworkTool.featureHashNetwork.filter(c => c.id_ == idFeature);

                    var featuresSimulation = null;

                    if (layerName === "g_pontos_consumo") {
                        featuresSimulation = mysearchNetworkTool.featureHashNetwork.filter(c => c.values_.cod_ponto_cons == id);
                        features = mysearchNetworkTool.featureHashNetwork.filter(c => c.id_ == featuresSimulation[0].id_);
                    }

                    // Get id layer
                    var idLayer = -1;
                    if (Object.keys(mysearchNetworkTool._resultRefDataSearch).length > 0)
                        idLayer = mysearchNetworkTool._resultRefDataSearch.layerByCodLayerMetadata.filter(c => $.trim(c.pretty_name).replaceAll(' ', '') == prettyName)[0].id;
                    else
                        idLayer = $(this.closest('table')).attr('id-layer');

                    // Get info element
                    var featureInfo = null;
                    if (features.length > 0)
                        featureInfo = {
                            id: id,
                            layer_name: layerName,
                            idLayer: idLayer,
                            feature: features[0],
                            mode: 'read',
                            fromMap: false
                        };
                    else
                        featureInfo = {
                            id: id,
                            layer_name: layerName,
                            idLayer: idLayer,
                            mode: 'read',
                            fromMap: false
                        };

                    // Set Detail
                    if (featureInfo)
                        gotoEntityDetailCallback(featureInfo);
                });

                // Goto element search in map 
                $('.button-goto-location-search-result-network').off('click').on('click', function (e) {
                    e.preventDefault();

                    var layerName = $(this.closest('table')).attr('layer-name');

                    // Get id element
                    var id = $(this).parent().parent()[0].id;
                    var idFeature = layerName + "." + id;

                    if (layerName === "g_pontos_consumo") {
                        var featuresSimulation = mysearchNetworkTool.featureHashNetwork.filter(c => c.values_.cod_ponto_cons == id);
                        idFeature = mysearchNetworkTool.featureHashNetwork.filter(c => c.id_ == featuresSimulation[0].id_)[0].id_;
                    }

                    // Remove highlight
                    mysearchNetworkTool._mapSgs.layerHighlightOverlay.getSource().clear();

                    // Get simul layer info
                    var layerSimulInfo = null;
                    if (mysearchNetworkTool._mapSgs._networkSimulationTool) {
                        layerSimulInfo = Object.values(mysearchNetworkTool._mapSgs._networkSimulationTool._layerInfoElementToClose).find(c => c.layerName == layerName);
                    }

                    // Remove 

                    // Highlight element and go to
                    mysearchNetworkTool._mapSgs.SetFeaturesHighlightByArray(worksapce, layerName, false, [idFeature], ((layerSimulInfo && layerSimulInfo.style) ? layerSimulInfo.style : undefined), true);

                    var verifyClass = $('#id-search-result-detail-info-number-result').hasClass('hide-highlight');

                    if (!verifyClass)
                        $('#id-search-result-detail-info-number-result').removeClass('hide-highlight');
                });

                // Open/Close datatable
                $('.networkSearchDatatable').off('click').on('click', function () {

                    if (this.id.split('label-')[1] != "") {

                        if ($('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').is(':visible'))
                            $('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').css('display', 'none');
                        else
                            $('#offcanvas-search-result-network-table-zone [id="div-' + this.id.split('label-')[1] + '"]').css('display', 'block');
                    }
                });

                // Open/Close datatable
                $('.networksearchExpand').on('click', function () {
                    var idLayer = $(this).attr("id-layer");
                    var listColumnDef = JSON.parse(JSON.stringify(mysearchNetworkTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(c => c.visible == true)));
                    listColumnDef.forEach(columnInfo => {
                        if (columnInfo.id_rel_layer_column_ref_metadata != null) {
                            columnInfo["values"] = mysearchNetworkTool._mapSgs._settings._mapSettings.column_table_reference_data.table_reference_data[columnInfo.id_rel_layer_column_ref_metadata].map(c => { return { value: c.id, text: c.value }; });
                        }
                    });
                    listColumnDef.sort((a, b) => (a["column_pos"] > b["column_pos"]) ? 1 : ((b["column_pos"] > a["column_pos"]) ? -1 : 0));
                    var title = $.trim($(this).siblings('label')[0].innerText).replaceAll(' ', '');

                    //mysearchNetworkTool.InitSearchResultTableExtend(mysearchNetworkTool._hashFeatures[$.trim($(this).siblings('label')[0].innerText).replaceAll(' ', '')], mysearchNetworkTool._columnDefArrayExpand[$.trim($(this).siblings('label')[0].innerText).replaceAll(' ', '')]);
                    mysearchNetworkTool._mapSgs.InitSearchResultTableExtend(mysearchNetworkTool._hashFeatures[$.trim($(this).siblings('label')[0].innerText).replaceAll(' ', '')], listColumnDef, title, true);
                });

                // Goto element predio info
                mysearchNetworkTool._mapSgs.tooltips._navisionTool.getAllClientByPredio('button-goto-webservice-network');
            }
        });
        tableResultSearch.draw();
    }

    /**
     * Init search result extend table
     * @param {any} worksapce
     * @param {any} layerName
     * @param {any} idLayer
     * @param {any} columnValueArray
     * @param {any} columnDefArrayExpand
     */
    this.InitSearchResultTableExtend = function (columnValueArray, columnDefArrayExpand, title) {

        // -- Table search result expand ----------------------------------------------------------
        const idMapListElement = 'offcanvas-map-list';
        const mapListElement = $(`#${idMapListElement}`);
        const gridSelector = '#offcanvas-map-list-result';// offcanvas-map-list-search-result-table-zone

        if (title) {
            const titleElement = mapListElement.find('li.active a');

            if (titleElement.length) {
                titleElement.text(title);
                titleElement.attr("title", title);
            }
        }

        const exportSelectorFieldZoneSelector = '#id-kendo-grid-choose-export-field-zone'
        const exportSelectorFieldZoneElement = $(exportSelectorFieldZoneSelector);

        const exportSelectorFieldSelector = '#id-kendo-grid-choose-export-field';
        const exportSelectorFieldElement = $(exportSelectorFieldSelector);

        const hideSelectorFieldZone = (e) => {
            if (e && buttonSelectFieldsExportElement.length && e.target.id != buttonSelectFieldsExportElement[0].id) {
                exportSelectorFieldZoneElement.hide();
            }
        }

        mapListElement.off("remove", hideSelectorFieldZone);

        $(document).off('click', hideSelectorFieldZone);

        // reset height
        mapListElement.height($('#map').height() * 0.55);

        let resizeWindow = () => {
            if (mapListElement.width() != $("#map").width()) {
                mapListElement.width($("#map").width());

                const elemPosition = mapListElement[0].getBoundingClientRect();

                if (elemPosition.x + 1 < $("#map").width() && elemPosition.x - 1 < $("#map").width()) {
                    app.sgs.Map._utility.ShowOpenCanvas3(idMapListElement, true);
                }
                hideSelectorFieldZone();
            }
        }

        window.removeEventListener('resize', resizeWindow);

        const cardHeadElement = mapListElement.find('.offcanvas-head');
        const cardBodyElement = mapListElement.find('.offcanvas-body');

        let panelHeight = mapListElement.height();
        const gridHeight = cardHeadElement.length ? panelHeight - cardHeadElement.height() : panelHeight - 20;

        if (cardBodyElement.length) {
            cardBodyElement.css('padding', '0px');
            const tabContentElement = cardBodyElement.find('.card-body.tab-content');

            if (tabContentElement.length) {
                tabContentElement.css('padding', '0px');
            }
        }

        // Empty table zone
        $(gridSelector).empty();
        // Empty field selector to export excel
        exportSelectorFieldElement.empty();

        let fields = {};
        let listColumns = [];

        // create columns config
        columnDefArrayExpand.map((column, index) => {

            let typeField = "string";

            switch (column.column_type) {
                case "xsd:int":
                case "xsd:double":
                    typeField = "number"
                    break
                default:
                    break
            }

            fields[column.column_name] = { type: typeField };

            if (column.visible) {
                listColumns.push({
                    field: column.column_name,
                    title: column.pretty_name,
                    groupable: false,
                    width: 150
                });

                $(mysearchNetworkTool._templateChooseFieldForExport.replaceAll("[TITLE]", column.pretty_name).replaceAll("[FIELD]", column.column_name)).appendTo(exportSelectorFieldSelector);
            }
        });

        // Grid
        $(gridSelector).kendoGrid({
            noRecords: {
                template: '<div style="text-align:center;min-height:40px;width: 100%;align-content:center;"><span>Não existem resultados</span></div>'
            },
            excel: {
                allPages: true,
                filterable: true
            },
            columnMenu: {
                componentType: "modern",
                columns: true
            },
            columnMenuOpen: (e) => {
                const listCheckbox = e.container.find('.k-column-list-item .k-checkbox');

                if (listCheckbox.length) {
                    listCheckbox.css("position", 'relative')
                    listCheckbox.css("left", '0px')
                    listCheckbox.css("opacity", '1')
                }
            },
            filterable: true,
            height: gridHeight,
            columns: listColumns,
            dataSource: {
                data: columnValueArray,
                schema: {
                    model: {
                        fields: fields
                    }
                },
                pageSize: mysearchNetworkTool._gridPageSize
            },
            toolbar: [
                { name: "excel", text: "Excel", iconClass: "k-icon k-i-file-excel" },
                { template: '<a role="button" id="id-button-select-fields-to-export" class="k-button k-button-icontext" href="\\#" title="Selecionar campos para exportação"><span class="k-icon k-i-columns"></span>Selecionar Campos</a>' },
                { template: '<a role="button" id="id-button-clear-filters" class="k-button k-button-icontext" href="\\#" title="Limpar os filtros"><i class="fa fa-filter" aria-hidden="true" style="margin-right: 5px;"></i>Limpar os filtros</a>' }
            ],
            pageable: true,
            scrollable: true,
            sortable: true,
            groupable: false,
            // editable: "inline",
            pageable: {
                pageSizes: [5, 10, 20, 50, "all"],
                input: true,
                numeric: true
            },
            excelExport: function (e) {

                var sheet = e.workbook.sheets[0];

                mysearchNetworkTool._BuildHiddenColumnsForExport();

                if (mysearchNetworkTool._hiddenColumnsForExport.length > 0) {
                    const filterColumns = [];

                    sheet.columns.map((column, index) => {
                        if (mysearchNetworkTool._hiddenColumnsForExport.indexOf(listColumns[index].field) > -1) {
                            filterColumns.push(index);
                        };
                    });

                    filterColumns.sort((a, b) => b - a);

                    sheet.rows.map((row, index) => {
                        filterColumns.map(position => row.cells.splice(position, 1));
                        if (index == 0) {
                            filterColumns.map(position => sheet.columns.splice(position, 1));
                        }
                    });
                }
            }
        });

        // Data grid
        let xgrid = $(gridSelector).data("kendoGrid");

        // Reset position of grid elements
        const topPosition = "-65px";
        let deltaHeight = 40;

        // Reset position of grid toolbar
        const toolbarElement = $(gridSelector).find('.k-toolbar.k-grid-toolbar');
        if (toolbarElement.length) {
            deltaHeight += toolbarElement.height();
            toolbarElement.css({
                "width": "100%",
                "top": topPosition
            })
        }

        // Reset position of grid header
        const headerElement = $(gridSelector).find('.k-grid-header');
        if (headerElement.length) {
            deltaHeight += headerElement.height();
            headerElement.css({
                "position": "relative",
                "top": topPosition
            })
        }

        // Reset position of grid pagination
        const paginationElement = $(gridSelector).find('.k-pager-wrap.k-grid-pager.k-widget.k-floatwrap');
        if (paginationElement.length) {
            deltaHeight += paginationElement.height();
            paginationElement.css({
                "top": topPosition,
                "position": "relative"
            })
        }

        // Reset position of grid content
        const contentElement = $(gridSelector).find('.k-grid-content');
        if (contentElement.length) {
            contentElement.css({
                "max-height": `${gridHeight - deltaHeight}px`,
                "top": topPosition
            });
        }

        const buttonSelectFieldsExportElement = $("#id-button-select-fields-to-export");

        /**
         * Grid - Event show field to choose to export 
         */
        buttonSelectFieldsExportElement.click((e) => {

            if (exportSelectorFieldZoneElement.is(':visible')) {
                exportSelectorFieldZoneElement.hide();
            }
            else {

                const panelPosicion = mapListElement.position();
                const headerPosicion = headerElement.position();
                const botonPosicion = buttonSelectFieldsExportElement.position();

                exportSelectorFieldZoneElement.css({
                    "top": panelPosicion.top + headerPosicion.top + botonPosicion.top + buttonSelectFieldsExportElement.outerHeight() + 20 + "px",
                    "left": panelPosicion.left + botonPosicion.left + "px",
                    "max-height": contentElement.height()
                });

                exportSelectorFieldZoneElement.show();
            }
        });

        /**
         * Grid - Event clean all filter
         */
        $("#id-button-clear-filters").click(() => {
            let gridDataSource = $(gridSelector).data("kendoGrid").dataSource;
            gridDataSource.filter({});
        });

        resizeWindow();

        // register resize event
        window.addEventListener('resize', resizeWindow);

        mapListElement.on("remove", hideSelectorFieldZone);

        $(document).on('click', hideSelectorFieldZone);

        exportSelectorFieldZoneElement.on('click', function (event) {
            event.stopPropagation();
        });

        // Hide canvas search result
        mysearchNetworkTool._mapSgs._utility.ShowOpenCanvas3('offcanvas-map-list', true);
    }

    this._BuildHiddenColumnsForExport = function () {
        for (var i = 0; i < $('#id-kendo-grid-choose-export-field input').length; i++) {
            var fieldName = $($('#id-kendo-grid-choose-export-field input')[i]).attr("data-field");
            var indexFieldNameInArray = mysearchNetworkTool._hiddenColumnsForExport.indexOf(fieldName);

            // Remove from array if field is check and field is on the array
            if ($($('#id-kendo-grid-choose-export-field input')[i]).is(":checked") && indexFieldNameInArray >= 0) {
                // Remove from array
                mysearchNetworkTool._hiddenColumnsForExport.splice(indexFieldNameInArray, 1);
            }

            // Add to array if field is not check and field is not in the array
            if (!$($('#id-kendo-grid-choose-export-field input')[i]).is(":checked") && indexFieldNameInArray == -1) {
                // Remove from array
                mysearchNetworkTool._hiddenColumnsForExport.push(fieldName);
            }
        }
    }

    /**
     * Get All documents
     */
    this.getAllDocumentsById = function () {

        $('#id-div-doc-network-result ul').empty();

        $.ajax({
            type: 'GET',
            url: '/rest/app/SearchNetworkProject/GetConstructionDoc?codConstruction=' + $('.open-search-cod-obra')[0].id,
            async: false,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da documentação");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':

                            $('#offcanvas-search-result-network-doc-zone').show();

                            if (data.result.listDoc.length > 0) {

                                $('.offcanvas-search-result-table-zone-title').addClass('ol-hidden');

                                for (var i = 0; i < data.result.listDoc.length; i++) {


                                    $('#id-div-doc-network-result ul').append('<li style="margin-bottom: 5px;" ><a id="id-download-file-details" class="' + data.result.listDoc[i].hiperligacao + '" style="color:blue;cursor: pointer;">link documentos</a></li>');


                                }

                                $('#id-download-file-details').off('click').on('click', function () {

                                    mysearchNetworkTool._mapSgs._utility.ShowWait('spinner-search-result', true);

                                    $('#spinner-search-result #offcanvas-entity-form-spinner').addClass('spinner-canvas-position-obras');

                                    $.ajax({
                                        type: 'POST',
                                        url: '/rest/app/FileManager/DownloadFileNAS?url=' + this.classList.value,
                                        dataType: 'json',
                                        contentType: "application/json",
                                        success: function (data) {


                                            $.ajax({
                                                type: 'POST',
                                                url: '/rest/app/FileManager/DownloadFileHost',
                                                dataType: 'json',
                                                contentType: "application/json",
                                                success: function (data) {


                                                    var link = document.createElement("a");
                                                    document.body.appendChild(link);
                                                    link.setAttribute("type", "hidden");
                                                    link.href = "data:text/plain;base64," + data.result;
                                                    link.download = "Download.zip";
                                                    link.click();
                                                    document.body.removeChild(link);

                                                    mysearchNetworkTool._mapSgs._utility.ShowWait('spinner-search-result', false);
                                                    $('#spinner-search-result #offcanvas-entity-form-spinner').removeClass('spinner-canvas-position-obras');

                                                },
                                                error: function (request, status, error) {
                                                    toastr["error"]("Erro ao descarregar ficheiros");
                                                    mysearchNetworkTool._mapSgs._utility.ShowWait('spinner-search-result', false);
                                                    $('#spinner-search-result #offcanvas-entity-form-spinner').removeClass('spinner-canvas-position-obras');
                                                }
                                            });


                                        },
                                        error: function (request, status, error) {
                                            toastr["error"]("Erro ao descarregar ficheiros da NAS");
                                            mysearchNetworkTool._mapSgs._utility.ShowWait('spinner-search-result', false);
                                            $('#spinner-search-result #offcanvas-entity-form-spinner').removeClass('spinner-canvas-position-obras');
                                        }
                                    });

                                });

                            } else {

                                $('#id-div-doc-network-result ul').append('<li style="margin-bottom: 5px;" ><a>Sem documentação</a></li>');

                            }

                            break;
                        default:
                            toastr["error"]("Erro na obtenção da documentação");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da documentação");
            }
        });
    }

    // -- start event -------------------------------------------------------------------------------    

    /**
     * Get result from search network
     */
    this.getLayersByCodObra = function () {

        $('.open-search-cod-obra').off('click').on('click', function () {
            // Start wait
            mysearchNetworkTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

            $('#offcanvas-search-result-network-table-zone .div-datatable-network').remove();

            $.ajax({
                type: 'GET',
                url: '/rest/app/SearchNetworkProject/GetAllReference?idMap=' + mysearchNetworkTool._mapSgs._settings._mapSettings.map_info.id,
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro obtenção da informação de referencia dos servicos OGC");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':

                                var DataResult = JSON.parse(data.result.listLayer.value);

                                mysearchNetworkTool.featureHashNetwork = [];

                                var stringTypeName = "";
                                var cqlFilter = "";
                                for (var i = 0; i < DataResult.length; i++) {

                                    stringTypeName += "(GP_DOUROGAS:" + DataResult[i].layer_name + ")";

                                    if (data.result.layerByCodLayerMetadata.length > 0 && data.result.layerByCodLayerMetadata[i].cql_filter != null) {

                                        cqlFilter += DataResult[i].column_project_name + " = '" + $('.open-search-cod-obra')[0].id + "' and " + data.result.layerByCodLayerMetadata[i].cql_filter + ";";

                                    } else {

                                        cqlFilter += DataResult[i].column_project_name + " = '" + $('.open-search-cod-obra')[0].id + "';";

                                    }

                                }

                                mysearchNetworkTool._resultRefDataSearch = data.result;
                                mysearchNetworkTool._resultRefDataSearch.listLayer = JSON.parse(data.result.listLayer.value);

                                cqlFilter = cqlFilter.slice(0, -1);

                                mysearchNetworkTool.GetAllFeaturesBySearch(stringTypeName, _GeoserverSearchNetwork, false, cqlFilter, null, null)

                                break;
                            default:
                                toastr["error"]("Erro obtenção da informação de referencia dos servicos OGC");
                        }
                    }
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro obtenção da informação de referencia dos servicos OGC");
                }
            });
        });

    };


    $('#label-documentos-download').off('click').on('click', function () {

        if ($('#id-div-doc-network-result').is(':visible'))
            $('#id-div-doc-network-result').css('display', 'none');
        else
            $('#id-div-doc-network-result').css('display', 'block');

    });
    // -- end event -------------------------------------------------------------------------------    
};

/**
 * Init ogc layer tool
 * @param {object} mapSgs, map object
 */
searchNetworkTool.prototype.Init = function (mapSgs) {
    // Set map info
    this._mapSgs = mapSgs;

    // Consumption point init
    this._hasConsumptionPoint = false;
    this._consumptionPointLayerName = "g_pontos_consumo";
}
